const baseURL = 'http://api.dmp.ydcz.cn/dmp-boot/';
export default baseURL
